import { default as _91_46_46_46not_45found_93KhGaSF9M9LMeta } from "C:/FE02/_work/333/s/Gallery/pages/[...not-found].vue?macro=true";
import { default as aboutDBRpt4q2sqMeta } from "C:/FE02/_work/333/s/Gallery/pages/about.vue?macro=true";
import { default as account_45createdTPbSGqcAsFMeta } from "C:/FE02/_work/333/s/Gallery/pages/account/account-created.vue?macro=true";
import { default as additional_45information24Mwba22WzMeta } from "C:/FE02/_work/333/s/Gallery/pages/account/additional-information.vue?macro=true";
import { default as addressesCyB5YkYu3uMeta } from "C:/FE02/_work/333/s/Gallery/pages/account/addresses.vue?macro=true";
import { default as amendmentn1cLNMwqaEMeta } from "C:/FE02/_work/333/s/Gallery/pages/account/amendment.vue?macro=true";
import { default as indexQ1ZW0V81z1Meta } from "C:/FE02/_work/333/s/Gallery/pages/account/bank-account/index.vue?macro=true";
import { default as requested48492GUqroMeta } from "C:/FE02/_work/333/s/Gallery/pages/account/bank-account/requested.vue?macro=true";
import { default as contract_45signingAyC3aMVJOSMeta } from "C:/FE02/_work/333/s/Gallery/pages/account/contract-signing.vue?macro=true";
import { default as document_45updateJAFa6yt3PSMeta } from "C:/FE02/_work/333/s/Gallery/pages/account/document-update.vue?macro=true";
import { default as documents_45checkCPmqnWr4y5Meta } from "C:/FE02/_work/333/s/Gallery/pages/account/documents-check.vue?macro=true";
import { default as index5BGgs4SMiWMeta } from "C:/FE02/_work/333/s/Gallery/pages/account/identity-verification/index.vue?macro=true";
import { default as requestedcCgLXrQM9kMeta } from "C:/FE02/_work/333/s/Gallery/pages/account/identity-verification/requested.vue?macro=true";
import { default as upload_45documentsK7TBCdjP0PMeta } from "C:/FE02/_work/333/s/Gallery/pages/account/identity-verification/upload-documents.vue?macro=true";
import { default as personal_45datavUPZwXpTlDMeta } from "C:/FE02/_work/333/s/Gallery/pages/account/personal-data.vue?macro=true";
import { default as phone_45number_45verificationKIjKzF7XiRMeta } from "C:/FE02/_work/333/s/Gallery/pages/account/phone-number-verification.vue?macro=true";
import { default as index5Fvdw9jXEsMeta } from "C:/FE02/_work/333/s/Gallery/pages/account/politically-exposed-person/index.vue?macro=true";
import { default as requestedrmfQN9I9uJMeta } from "C:/FE02/_work/333/s/Gallery/pages/account/politically-exposed-person/requested.vue?macro=true";
import { default as questionnaireEsM9M6Y0njMeta } from "C:/FE02/_work/333/s/Gallery/pages/account/questionnaire.vue?macro=true";
import { default as indexFCnpAUiHHaMeta } from "C:/FE02/_work/333/s/Gallery/pages/account/source-of-income-statement/index.vue?macro=true";
import { default as requestedmfKa7qts8IMeta } from "C:/FE02/_work/333/s/Gallery/pages/account/source-of-income-statement/requested.vue?macro=true";
import { default as verification9LnfxAH4BcMeta } from "C:/FE02/_work/333/s/Gallery/pages/account/verification.vue?macro=true";
import { default as annual_45reports2IYCr54geWMeta } from "C:/FE02/_work/333/s/Gallery/pages/annual-reports.vue?macro=true";
import { default as bankidRB8kBSNQyeMeta } from "C:/FE02/_work/333/s/Gallery/pages/bankid.vue?macro=true";
import { default as contactfMhZZlxYm0Meta } from "C:/FE02/_work/333/s/Gallery/pages/contact.vue?macro=true";
import { default as contractual_45documentationG14kQFibBoMeta } from "C:/FE02/_work/333/s/Gallery/pages/contractual-documentation.vue?macro=true";
import { default as _91id_93KxBI2UxEXdMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/advertising-space/[id].vue?macro=true";
import { default as _91id_93wpfkBQebP5Meta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/advertising-space/advertisement/[id].vue?macro=true";
import { default as newqs99ikF43WMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/advertising-space/advertisement/new.vue?macro=true";
import { default as indexzKIIZi8K5aMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/advertising-space/index.vue?macro=true";
import { default as my_45advertisementsBhSGO3pXrwMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/advertising-space/my-advertisements.vue?macro=true";
import { default as termsAUIrUYrJbGMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/advertising-space/terms.vue?macro=true";
import { default as _91id_93ssPAqR8QmvMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/advertising-space/trades/[id].vue?macro=true";
import { default as index8D6UbwsCl3Meta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/advertising-space/trades/index.vue?macro=true";
import { default as newjHSqp0ebLsMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/advertising-space/trades/new.vue?macro=true";
import { default as advertising_45space0g528lqFHvMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/advertising-space.vue?macro=true";
import { default as depositbln6xVR7aVMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/finance/deposit.vue?macro=true";
import { default as indexFqDKhPAL0UMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/finance/index.vue?macro=true";
import { default as purchase_45instructionsy0dMSsV0IvMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/finance/purchase-instructions.vue?macro=true";
import { default as transactions_45historyAZTbOSypHOMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/finance/transactions-history.vue?macro=true";
import { default as confirmationl0d0Qzk7eAMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/finance/withdrawal/confirmation.vue?macro=true";
import { default as index9iKx4Y1cZ1Meta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/finance/withdrawal/index.vue?macro=true";
import { default as financecxdjCUXJZFMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/finance.vue?macro=true";
import { default as indexpiGd6qLrZSMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/gifts-and-benefits/index.vue?macro=true";
import { default as unique_45exhibition_45alfons_45muchae0SaGjYDMOMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/gifts-and-benefits/unique-exhibition-alfons-mucha.vue?macro=true";
import { default as vouchersV4m6M5oK3RMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/gifts-and-benefits/vouchers.vue?macro=true";
import { default as gifts_45and_45benefitsIB4j415uEUMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/gifts-and-benefits.vue?macro=true";
import { default as index0EOwT3311RMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/index.vue?macro=true";
import { default as indexzgWNs4rPGcMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/investments/index.vue?macro=true";
import { default as _91slug_93mBdOW4NjV9Meta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/investments/investments-offer/[slug].vue?macro=true";
import { default as indexIevE9cOSKAMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/investments/investments-offer/index.vue?macro=true";
import { default as investments_45offerTTSiwmocCnMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/investments/investments-offer.vue?macro=true";
import { default as my_45investmentsrDsnXH5nPuMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/investments/my-investments.vue?macro=true";
import { default as votingLQJidJdMq8Meta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/investments/voting.vue?macro=true";
import { default as investmentsKAbDj0UqrIMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/investments.vue?macro=true";
import { default as add_45accountsNAbTSj8YaMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/add-account.vue?macro=true";
import { default as additional_45settingsbxnBvmBT7iMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/additional-settings.vue?macro=true";
import { default as indexa8esq9TNa8Meta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/bank-accounts/add/index.vue?macro=true";
import { default as requestedf8IP0ac66dMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/bank-accounts/add/requested.vue?macro=true";
import { default as upload_45documentaHn4Ym3RZFMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/bank-accounts/add/upload-document.vue?macro=true";
import { default as indexRhPIuBk0MZMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/bank-accounts/index.vue?macro=true";
import { default as delete_45account7f2WVfSsCnMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/delete-account.vue?macro=true";
import { default as index3YisySqiUUMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/document-update/index.vue?macro=true";
import { default as requested7Irg7sTBzQMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/document-update/requested.vue?macro=true";
import { default as edit_45personal_45informationMY5g1IjW4RMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/edit-personal-information.vue?macro=true";
import { default as email_45changefCuvkFJsxmMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/email-change.vue?macro=true";
import { default as email_45preferencesNp6sCbnGkZMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/email-preferences.vue?macro=true";
import { default as czech_45pointXMOvb6Ym9CMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/identity-verification/czech-point.vue?macro=true";
import { default as indext7nD8Cpqu1Meta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/identity-verification/index.vue?macro=true";
import { default as indexvJqbLhdUcXMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/index.vue?macro=true";
import { default as mailing_45address_45changeAAUXNJ72c5Meta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/mailing-address-change.vue?macro=true";
import { default as indexvFVsFYbRSzMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/name-change/index.vue?macro=true";
import { default as requestedZAFnfTYnVfMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/name-change/requested.vue?macro=true";
import { default as upload_45documentslw5lhrP3v5Meta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/name-change/upload-documents.vue?macro=true";
import { default as index63SVbAvTk6Meta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/permanent-address-change/index.vue?macro=true";
import { default as requested904SLTDOy8Meta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/permanent-address-change/requested.vue?macro=true";
import { default as upload_45documentsXJd1hn9VUvMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/permanent-address-change/upload-documents.vue?macro=true";
import { default as additional_45informationCLgafBGkErMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/personal-data-confirmation/additional-information.vue?macro=true";
import { default as indexazuYDqQSHsMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/personal-data-confirmation/index.vue?macro=true";
import { default as index5kDwSPFfEjMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/personal-data-confirmation/new-document/index.vue?macro=true";
import { default as requestedRBlrvZr7gUMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/personal-data-confirmation/new-document/requested.vue?macro=true";
import { default as indexnnAV0mZ64OMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/personal-data-confirmation/politically-exposed-person/index.vue?macro=true";
import { default as requested3WF68ysyLbMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/personal-data-confirmation/politically-exposed-person/requested.vue?macro=true";
import { default as indexrBJnIa3dKIMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/personal-data-confirmation/source-of-income-statement/index.vue?macro=true";
import { default as requestedIZeSkKDKGkMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/personal-data-confirmation/source-of-income-statement/requested.vue?macro=true";
import { default as personal_45data_45confirmation3ExonrNP6KMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/personal-data-confirmation.vue?macro=true";
import { default as phone_45changeUAhiBCOEgfMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/phone-change.vue?macro=true";
import { default as indexHhPndUM5oeMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/security/index.vue?macro=true";
import { default as password_45changem74JQH9VpOMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/security/password-change.vue?macro=true";
import { default as documents3H0iKZOq5QMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/statements-and-documents/documents.vue?macro=true";
import { default as indexTHxDA4WM5BMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/statements-and-documents/index.vue?macro=true";
import { default as statements_45and_45confirmationsycL7Y1rpZEMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/statements-and-documents/statements-and-confirmations.vue?macro=true";
import { default as profileto2t7t7JCrMeta } from "C:/FE02/_work/333/s/Gallery/pages/dashboard/profile.vue?macro=true";
import { default as elementWfYuUd42TAMeta } from "C:/FE02/_work/333/s/Gallery/pages/element.vue?macro=true";
import { default as email_45verificationo1qgEblCjKMeta } from "C:/FE02/_work/333/s/Gallery/pages/external/email-verification.vue?macro=true";
import { default as impersonation80OHRpaFDwMeta } from "C:/FE02/_work/333/s/Gallery/pages/external/impersonation.vue?macro=true";
import { default as logink6nUGDLZfIMeta } from "C:/FE02/_work/333/s/Gallery/pages/external/login.vue?macro=true";
import { default as password_45resetk1N6jOTU9gMeta } from "C:/FE02/_work/333/s/Gallery/pages/external/password-reset.vue?macro=true";
import { default as _91slug_93aAzVjQyXa5Meta } from "C:/FE02/_work/333/s/Gallery/pages/faq/[slug].vue?macro=true";
import { default as indexsOOjN1fW5NMeta } from "C:/FE02/_work/333/s/Gallery/pages/faq/index.vue?macro=true";
import { default as faq9eXkZ4eybDMeta } from "C:/FE02/_work/333/s/Gallery/pages/faq.vue?macro=true";
import { default as forgotten_45password7zGvjbA7mIMeta } from "C:/FE02/_work/333/s/Gallery/pages/forgotten-password.vue?macro=true";
import { default as how_45does_45it_45work2weXpFQ6G9Meta } from "C:/FE02/_work/333/s/Gallery/pages/how-does-it-work.vue?macro=true";
import { default as indexorbw1vnw9vMeta } from "C:/FE02/_work/333/s/Gallery/pages/index.vue?macro=true";
import { default as _91slug_93eURxcez7OeMeta } from "C:/FE02/_work/333/s/Gallery/pages/investments-offer/[slug].vue?macro=true";
import { default as indexYPkorF4HzCMeta } from "C:/FE02/_work/333/s/Gallery/pages/investments-offer/index.vue?macro=true";
import { default as loginwm5pEiN65jMeta } from "C:/FE02/_work/333/s/Gallery/pages/login.vue?macro=true";
import { default as obligatory_45published_45information6gcwQ7lj5OMeta } from "C:/FE02/_work/333/s/Gallery/pages/obligatory-published-information.vue?macro=true";
import { default as privacy_45settingswi66pnb0RsMeta } from "C:/FE02/_work/333/s/Gallery/pages/privacy-settings.vue?macro=true";
import { default as registrationXDRpjPEnTRMeta } from "C:/FE02/_work/333/s/Gallery/pages/registration.vue?macro=true";
import { default as securityvxa33lW2myMeta } from "C:/FE02/_work/333/s/Gallery/pages/security.vue?macro=true";
export default [
  {
    name: "notfound___cs___default",
    path: "/:notfound(.*)*",
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/[...not-found].vue").then(m => m.default || m)
  },
  {
    name: "notfound___cs",
    path: "/cs/:notfound(.*)*",
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/[...not-found].vue").then(m => m.default || m)
  },
  {
    name: "about___cs___default",
    path: "/o-nas",
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/about.vue").then(m => m.default || m)
  },
  {
    name: "about___cs",
    path: "/cs/o-nas",
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/about.vue").then(m => m.default || m)
  },
  {
    name: "account-account-created___cs___default",
    path: "/ucet/ucet-vytvoren",
    meta: account_45createdTPbSGqcAsFMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/account/account-created.vue").then(m => m.default || m)
  },
  {
    name: "account-account-created___cs",
    path: "/cs/ucet/ucet-vytvoren",
    meta: account_45createdTPbSGqcAsFMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/account/account-created.vue").then(m => m.default || m)
  },
  {
    name: "account-additional-information___cs___default",
    path: "/ucet/dalsi-informace",
    meta: additional_45information24Mwba22WzMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/account/additional-information.vue").then(m => m.default || m)
  },
  {
    name: "account-additional-information___cs",
    path: "/cs/ucet/dalsi-informace",
    meta: additional_45information24Mwba22WzMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/account/additional-information.vue").then(m => m.default || m)
  },
  {
    name: "account-addresses___cs___default",
    path: "/ucet/adresy",
    meta: addressesCyB5YkYu3uMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/account/addresses.vue").then(m => m.default || m)
  },
  {
    name: "account-addresses___cs",
    path: "/cs/ucet/adresy",
    meta: addressesCyB5YkYu3uMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/account/addresses.vue").then(m => m.default || m)
  },
  {
    name: "account-amendment___cs___default",
    path: "/ucet/dodatek",
    meta: amendmentn1cLNMwqaEMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/account/amendment.vue").then(m => m.default || m)
  },
  {
    name: "account-amendment___cs",
    path: "/cs/ucet/dodatek",
    meta: amendmentn1cLNMwqaEMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/account/amendment.vue").then(m => m.default || m)
  },
  {
    name: "account-bank-account___cs___default",
    path: "/ucet/bankovni-ucet",
    meta: indexQ1ZW0V81z1Meta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/account/bank-account/index.vue").then(m => m.default || m)
  },
  {
    name: "account-bank-account___cs",
    path: "/cs/ucet/bankovni-ucet",
    meta: indexQ1ZW0V81z1Meta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/account/bank-account/index.vue").then(m => m.default || m)
  },
  {
    name: "account-bank-account-requested___cs___default",
    path: "/ucet/bankovni-ucet/overeni",
    meta: requested48492GUqroMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/account/bank-account/requested.vue").then(m => m.default || m)
  },
  {
    name: "account-bank-account-requested___cs",
    path: "/cs/ucet/bankovni-ucet/overeni",
    meta: requested48492GUqroMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/account/bank-account/requested.vue").then(m => m.default || m)
  },
  {
    name: "account-contract-signing___cs___default",
    path: "/ucet/podpis-smlouvy",
    meta: contract_45signingAyC3aMVJOSMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/account/contract-signing.vue").then(m => m.default || m)
  },
  {
    name: "account-contract-signing___cs",
    path: "/cs/ucet/podpis-smlouvy",
    meta: contract_45signingAyC3aMVJOSMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/account/contract-signing.vue").then(m => m.default || m)
  },
  {
    name: "account-document-update___cs___default",
    path: "/ucet/aktualizace-dokladu",
    meta: document_45updateJAFa6yt3PSMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/account/document-update.vue").then(m => m.default || m)
  },
  {
    name: "account-document-update___cs",
    path: "/cs/ucet/aktualizace-dokladu",
    meta: document_45updateJAFa6yt3PSMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/account/document-update.vue").then(m => m.default || m)
  },
  {
    name: "account-documents-check___cs___default",
    path: "/ucet/kontrola-dokladu",
    meta: documents_45checkCPmqnWr4y5Meta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/account/documents-check.vue").then(m => m.default || m)
  },
  {
    name: "account-documents-check___cs",
    path: "/cs/ucet/kontrola-dokladu",
    meta: documents_45checkCPmqnWr4y5Meta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/account/documents-check.vue").then(m => m.default || m)
  },
  {
    name: "account-identity-verification___cs___default",
    path: "/ucet/overeni-identity",
    meta: index5BGgs4SMiWMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/account/identity-verification/index.vue").then(m => m.default || m)
  },
  {
    name: "account-identity-verification___cs",
    path: "/cs/ucet/overeni-identity",
    meta: index5BGgs4SMiWMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/account/identity-verification/index.vue").then(m => m.default || m)
  },
  {
    name: "account-identity-verification-requested___cs___default",
    path: "/ucet/overeni-identity/overeni",
    meta: requestedcCgLXrQM9kMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/account/identity-verification/requested.vue").then(m => m.default || m)
  },
  {
    name: "account-identity-verification-requested___cs",
    path: "/cs/ucet/overeni-identity/overeni",
    meta: requestedcCgLXrQM9kMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/account/identity-verification/requested.vue").then(m => m.default || m)
  },
  {
    name: "account-identity-verification-upload-documents___cs___default",
    path: "/ucet/overeni-identity/nahrat-doklady",
    meta: upload_45documentsK7TBCdjP0PMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/account/identity-verification/upload-documents.vue").then(m => m.default || m)
  },
  {
    name: "account-identity-verification-upload-documents___cs",
    path: "/cs/ucet/overeni-identity/nahrat-doklady",
    meta: upload_45documentsK7TBCdjP0PMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/account/identity-verification/upload-documents.vue").then(m => m.default || m)
  },
  {
    name: "account-personal-data___cs___default",
    path: "/ucet/osobni-udaje",
    meta: personal_45datavUPZwXpTlDMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/account/personal-data.vue").then(m => m.default || m)
  },
  {
    name: "account-personal-data___cs",
    path: "/cs/ucet/osobni-udaje",
    meta: personal_45datavUPZwXpTlDMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/account/personal-data.vue").then(m => m.default || m)
  },
  {
    name: "account-phone-number-verification___cs___default",
    path: "/ucet/overeni-telefonniho-cisla",
    meta: phone_45number_45verificationKIjKzF7XiRMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/account/phone-number-verification.vue").then(m => m.default || m)
  },
  {
    name: "account-phone-number-verification___cs",
    path: "/cs/ucet/overeni-telefonniho-cisla",
    meta: phone_45number_45verificationKIjKzF7XiRMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/account/phone-number-verification.vue").then(m => m.default || m)
  },
  {
    name: "account-politically-exposed-person___cs___default",
    path: "/ucet/politicky-exponovana-osoba",
    meta: index5Fvdw9jXEsMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/account/politically-exposed-person/index.vue").then(m => m.default || m)
  },
  {
    name: "account-politically-exposed-person___cs",
    path: "/cs/ucet/politicky-exponovana-osoba",
    meta: index5Fvdw9jXEsMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/account/politically-exposed-person/index.vue").then(m => m.default || m)
  },
  {
    name: "account-politically-exposed-person-requested___cs___default",
    path: "/ucet/politicky-exponovana-osoba/overeni",
    meta: requestedrmfQN9I9uJMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/account/politically-exposed-person/requested.vue").then(m => m.default || m)
  },
  {
    name: "account-politically-exposed-person-requested___cs",
    path: "/cs/ucet/politicky-exponovana-osoba/overeni",
    meta: requestedrmfQN9I9uJMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/account/politically-exposed-person/requested.vue").then(m => m.default || m)
  },
  {
    name: "account-questionnaire___cs___default",
    path: "/ucet/dotaznik",
    meta: questionnaireEsM9M6Y0njMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/account/questionnaire.vue").then(m => m.default || m)
  },
  {
    name: "account-questionnaire___cs",
    path: "/cs/ucet/dotaznik",
    meta: questionnaireEsM9M6Y0njMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/account/questionnaire.vue").then(m => m.default || m)
  },
  {
    name: "account-source-of-income-statement___cs___default",
    path: "/ucet/potvrzeni-zdroje-prijmu",
    meta: indexFCnpAUiHHaMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/account/source-of-income-statement/index.vue").then(m => m.default || m)
  },
  {
    name: "account-source-of-income-statement___cs",
    path: "/cs/ucet/potvrzeni-zdroje-prijmu",
    meta: indexFCnpAUiHHaMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/account/source-of-income-statement/index.vue").then(m => m.default || m)
  },
  {
    name: "account-source-of-income-statement-requested___cs___default",
    path: "/ucet/potvrzeni-zdroje-prijmu/overeni",
    meta: requestedmfKa7qts8IMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/account/source-of-income-statement/requested.vue").then(m => m.default || m)
  },
  {
    name: "account-source-of-income-statement-requested___cs",
    path: "/cs/ucet/potvrzeni-zdroje-prijmu/overeni",
    meta: requestedmfKa7qts8IMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/account/source-of-income-statement/requested.vue").then(m => m.default || m)
  },
  {
    name: "account-verification___cs___default",
    path: "/ucet/verifikace",
    meta: verification9LnfxAH4BcMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/account/verification.vue").then(m => m.default || m)
  },
  {
    name: "account-verification___cs",
    path: "/cs/ucet/verifikace",
    meta: verification9LnfxAH4BcMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/account/verification.vue").then(m => m.default || m)
  },
  {
    name: "annual-reports___cs___default",
    path: "/vyrocni-zpravy",
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/annual-reports.vue").then(m => m.default || m)
  },
  {
    name: "annual-reports___cs",
    path: "/cs/vyrocni-zpravy",
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/annual-reports.vue").then(m => m.default || m)
  },
  {
    name: "bankid___cs___default",
    path: "/bankid",
    meta: bankidRB8kBSNQyeMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/bankid.vue").then(m => m.default || m)
  },
  {
    name: "bankid___cs",
    path: "/cs/bankid",
    meta: bankidRB8kBSNQyeMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/bankid.vue").then(m => m.default || m)
  },
  {
    name: "contact___cs___default",
    path: "/kontakt",
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: "contact___cs",
    path: "/cs/kontakt",
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: "contractual-documentation___cs___default",
    path: "/smluvni-dokumentace",
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/contractual-documentation.vue").then(m => m.default || m)
  },
  {
    name: "contractual-documentation___cs",
    path: "/cs/smluvni-dokumentace",
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/contractual-documentation.vue").then(m => m.default || m)
  },
  {
    name: advertising_45space0g528lqFHvMeta?.name,
    path: "/souhrn/inzertni-plocha",
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/advertising-space.vue").then(m => m.default || m),
    children: [
  {
    name: "dashboard-advertising-space-id___cs___default",
    path: ":id()",
    meta: _91id_93KxBI2UxEXdMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/advertising-space/[id].vue").then(m => m.default || m)
  },
  {
    name: "dashboard-advertising-space-advertisement-id___cs___default",
    path: "inzerat/:id()",
    meta: _91id_93wpfkBQebP5Meta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/advertising-space/advertisement/[id].vue").then(m => m.default || m)
  },
  {
    name: "dashboard-advertising-space-advertisement-new___cs___default",
    path: "inzerat/novy",
    meta: newqs99ikF43WMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/advertising-space/advertisement/new.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-advertising-space___cs___default",
    path: "/souhrn/inzertni-plocha",
    meta: indexzKIIZi8K5aMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/advertising-space/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-advertising-space-my-advertisements___cs___default",
    path: "moje-inzeraty",
    meta: my_45advertisementsBhSGO3pXrwMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/advertising-space/my-advertisements.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-advertising-space-terms___cs___default",
    path: "podminky",
    meta: termsAUIrUYrJbGMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/advertising-space/terms.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-advertising-space-trades-id___cs___default",
    path: "pokyny-k-prevodu/:id()",
    meta: _91id_93ssPAqR8QmvMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/advertising-space/trades/[id].vue").then(m => m.default || m)
  },
  {
    name: "dashboard-advertising-space-trades___cs___default",
    path: "pokyny-k-prevodu",
    meta: index8D6UbwsCl3Meta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/advertising-space/trades/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-advertising-space-trades-new___cs___default",
    path: "pokyny-k-prevodu/novy",
    meta: newjHSqp0ebLsMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/advertising-space/trades/new.vue").then(m => m.default || m)
  }
]
  },
  {
    name: advertising_45space0g528lqFHvMeta?.name,
    path: "/cs/souhrn/inzertni-plocha",
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/advertising-space.vue").then(m => m.default || m),
    children: [
  {
    name: "dashboard-advertising-space-id___cs",
    path: ":id()",
    meta: _91id_93KxBI2UxEXdMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/advertising-space/[id].vue").then(m => m.default || m)
  },
  {
    name: "dashboard-advertising-space-advertisement-id___cs",
    path: "inzerat/:id()",
    meta: _91id_93wpfkBQebP5Meta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/advertising-space/advertisement/[id].vue").then(m => m.default || m)
  },
  {
    name: "dashboard-advertising-space-advertisement-new___cs",
    path: "inzerat/novy",
    meta: newqs99ikF43WMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/advertising-space/advertisement/new.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-advertising-space___cs",
    path: "/cs/souhrn/inzertni-plocha",
    meta: indexzKIIZi8K5aMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/advertising-space/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-advertising-space-my-advertisements___cs",
    path: "moje-inzeraty",
    meta: my_45advertisementsBhSGO3pXrwMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/advertising-space/my-advertisements.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-advertising-space-terms___cs",
    path: "podminky",
    meta: termsAUIrUYrJbGMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/advertising-space/terms.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-advertising-space-trades-id___cs",
    path: "pokyny-k-prevodu/:id()",
    meta: _91id_93ssPAqR8QmvMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/advertising-space/trades/[id].vue").then(m => m.default || m)
  },
  {
    name: "dashboard-advertising-space-trades___cs",
    path: "pokyny-k-prevodu",
    meta: index8D6UbwsCl3Meta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/advertising-space/trades/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-advertising-space-trades-new___cs",
    path: "pokyny-k-prevodu/novy",
    meta: newjHSqp0ebLsMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/advertising-space/trades/new.vue").then(m => m.default || m)
  }
]
  },
  {
    name: financecxdjCUXJZFMeta?.name,
    path: "/souhrn/penize",
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/finance.vue").then(m => m.default || m),
    children: [
  {
    name: "dashboard-finance-deposit___cs___default",
    path: "vklad",
    meta: depositbln6xVR7aVMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/finance/deposit.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-finance___cs___default",
    path: "/souhrn/penize",
    meta: indexFqDKhPAL0UMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/finance/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-finance-purchase-instructions___cs___default",
    path: "pokyny",
    meta: purchase_45instructionsy0dMSsV0IvMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/finance/purchase-instructions.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-finance-transactions-history___cs___default",
    path: "transakcni-historie",
    meta: transactions_45historyAZTbOSypHOMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/finance/transactions-history.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-finance-withdrawal-confirmation___cs___default",
    path: "vyber/potvrzeni",
    meta: confirmationl0d0Qzk7eAMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/finance/withdrawal/confirmation.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-finance-withdrawal___cs___default",
    path: "vyber",
    meta: index9iKx4Y1cZ1Meta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/finance/withdrawal/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: financecxdjCUXJZFMeta?.name,
    path: "/cs/souhrn/penize",
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/finance.vue").then(m => m.default || m),
    children: [
  {
    name: "dashboard-finance-deposit___cs",
    path: "vklad",
    meta: depositbln6xVR7aVMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/finance/deposit.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-finance___cs",
    path: "/cs/souhrn/penize",
    meta: indexFqDKhPAL0UMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/finance/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-finance-purchase-instructions___cs",
    path: "pokyny",
    meta: purchase_45instructionsy0dMSsV0IvMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/finance/purchase-instructions.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-finance-transactions-history___cs",
    path: "transakcni-historie",
    meta: transactions_45historyAZTbOSypHOMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/finance/transactions-history.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-finance-withdrawal-confirmation___cs",
    path: "vyber/potvrzeni",
    meta: confirmationl0d0Qzk7eAMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/finance/withdrawal/confirmation.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-finance-withdrawal___cs",
    path: "vyber",
    meta: index9iKx4Y1cZ1Meta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/finance/withdrawal/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: gifts_45and_45benefitsIB4j415uEUMeta?.name,
    path: "/souhrn/darky-a-vyhody",
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/gifts-and-benefits.vue").then(m => m.default || m),
    children: [
  {
    name: "dashboard-gifts-and-benefits___cs___default",
    path: "",
    meta: indexpiGd6qLrZSMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/gifts-and-benefits/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-gifts-and-benefits-unique-exhibition-alfons-mucha___cs___default",
    path: "unikatni-vystava-alfons-mucha",
    meta: unique_45exhibition_45alfons_45muchae0SaGjYDMOMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/gifts-and-benefits/unique-exhibition-alfons-mucha.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-gifts-and-benefits-vouchers___cs___default",
    path: "darkove-poukazy",
    meta: vouchersV4m6M5oK3RMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/gifts-and-benefits/vouchers.vue").then(m => m.default || m)
  }
]
  },
  {
    name: gifts_45and_45benefitsIB4j415uEUMeta?.name,
    path: "/cs/souhrn/darky-a-vyhody",
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/gifts-and-benefits.vue").then(m => m.default || m),
    children: [
  {
    name: "dashboard-gifts-and-benefits___cs",
    path: "",
    meta: indexpiGd6qLrZSMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/gifts-and-benefits/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-gifts-and-benefits-unique-exhibition-alfons-mucha___cs",
    path: "unikatni-vystava-alfons-mucha",
    meta: unique_45exhibition_45alfons_45muchae0SaGjYDMOMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/gifts-and-benefits/unique-exhibition-alfons-mucha.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-gifts-and-benefits-vouchers___cs",
    path: "darkove-poukazy",
    meta: vouchersV4m6M5oK3RMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/gifts-and-benefits/vouchers.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "dashboard___cs___default",
    path: "/souhrn",
    meta: index0EOwT3311RMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard___cs",
    path: "/cs/souhrn",
    meta: index0EOwT3311RMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/index.vue").then(m => m.default || m)
  },
  {
    name: investmentsKAbDj0UqrIMeta?.name,
    path: "/souhrn/investice",
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/investments.vue").then(m => m.default || m),
    children: [
  {
    name: "dashboard-investments___cs___default",
    path: "",
    meta: indexzgWNs4rPGcMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/investments/index.vue").then(m => m.default || m)
  },
  {
    name: investments_45offerTTSiwmocCnMeta?.name,
    path: "nabidka-investic",
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/investments/investments-offer.vue").then(m => m.default || m),
    children: [
  {
    name: "dashboard-investments-investments-offer-slug___cs___default",
    path: "/souhrn/investice/:slug()",
    meta: _91slug_93mBdOW4NjV9Meta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/investments/investments-offer/[slug].vue").then(m => m.default || m)
  },
  {
    name: "dashboard-investments-investments-offer___cs___default",
    path: "/souhrn/investice/nabidka-investic",
    meta: indexIevE9cOSKAMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/investments/investments-offer/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "dashboard-investments-my-investments___cs___default",
    path: "moje-investice",
    meta: my_45investmentsrDsnXH5nPuMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/investments/my-investments.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-investments-voting___cs___default",
    path: "hlasovani",
    meta: votingLQJidJdMq8Meta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/investments/voting.vue").then(m => m.default || m)
  }
]
  },
  {
    name: investmentsKAbDj0UqrIMeta?.name,
    path: "/cs/souhrn/investice",
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/investments.vue").then(m => m.default || m),
    children: [
  {
    name: "dashboard-investments___cs",
    path: "",
    meta: indexzgWNs4rPGcMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/investments/index.vue").then(m => m.default || m)
  },
  {
    name: investments_45offerTTSiwmocCnMeta?.name,
    path: "nabidka-investic",
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/investments/investments-offer.vue").then(m => m.default || m),
    children: [
  {
    name: "dashboard-investments-investments-offer-slug___cs",
    path: "/cs/souhrn/investice/:slug()",
    meta: _91slug_93mBdOW4NjV9Meta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/investments/investments-offer/[slug].vue").then(m => m.default || m)
  },
  {
    name: "dashboard-investments-investments-offer___cs",
    path: "/cs/souhrn/investice/nabidka-investic",
    meta: indexIevE9cOSKAMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/investments/investments-offer/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "dashboard-investments-my-investments___cs",
    path: "moje-investice",
    meta: my_45investmentsrDsnXH5nPuMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/investments/my-investments.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-investments-voting___cs",
    path: "hlasovani",
    meta: votingLQJidJdMq8Meta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/investments/voting.vue").then(m => m.default || m)
  }
]
  },
  {
    name: profileto2t7t7JCrMeta?.name,
    path: "/dashboard/profile",
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile.vue").then(m => m.default || m),
    children: [
  {
    name: "dashboard-profile-add-account___cs___default",
    path: "/souhrn/profil/pridat-ucet",
    meta: add_45accountsNAbTSj8YaMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/add-account.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-additional-settings___cs___default",
    path: "/souhrn/profil/dalsi-nastaveni",
    meta: additional_45settingsbxnBvmBT7iMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/additional-settings.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-bank-accounts-add___cs___default",
    path: "/souhrn/profil/bankovni-ucty/pridat",
    meta: indexa8esq9TNa8Meta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/bank-accounts/add/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-bank-accounts-add-requested___cs___default",
    path: "/souhrn/profil/bankovni-ucty/pridat/overeni",
    meta: requestedf8IP0ac66dMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/bank-accounts/add/requested.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-bank-accounts-add-upload-document___cs___default",
    path: "/souhrn/profil/bankovni-ucty/pridat/nahrat-doklad",
    meta: upload_45documentaHn4Ym3RZFMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/bank-accounts/add/upload-document.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-bank-accounts___cs___default",
    path: "/souhrn/profil/bankovni-ucty",
    meta: indexRhPIuBk0MZMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/bank-accounts/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-delete-account___cs___default",
    path: "/souhrn/profil/zruseni-uctu",
    meta: delete_45account7f2WVfSsCnMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/delete-account.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-document-update___cs___default",
    path: "/souhrn/profil/aktualizace-dokladu",
    meta: index3YisySqiUUMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/document-update/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-document-update-requested___cs___default",
    path: "/souhrn/profil/aktualizace-dokladu/overeni",
    meta: requested7Irg7sTBzQMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/document-update/requested.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-edit-personal-information___cs___default",
    path: "/souhrn/profil/uprava-osobnich-udaju",
    meta: edit_45personal_45informationMY5g1IjW4RMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/edit-personal-information.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-email-change___cs___default",
    path: "/souhrn/profil/zmena-e-mailu",
    meta: email_45changefCuvkFJsxmMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/email-change.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-email-preferences___cs___default",
    path: "/souhrn/profil/e-mailova-sdeleni",
    meta: email_45preferencesNp6sCbnGkZMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/email-preferences.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-identity-verification-czech-point___cs___default",
    path: "/souhrn/profil/overeni-totoznosti/czech-point",
    meta: czech_45pointXMOvb6Ym9CMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/identity-verification/czech-point.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-identity-verification___cs___default",
    path: "/souhrn/profil/overeni-totoznosti",
    meta: indext7nD8Cpqu1Meta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/identity-verification/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile___cs___default",
    path: "/souhrn/profil",
    meta: indexvJqbLhdUcXMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-mailing-address-change___cs___default",
    path: "/souhrn/profil/zmena-korespondencni-adresy",
    meta: mailing_45address_45changeAAUXNJ72c5Meta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/mailing-address-change.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-name-change___cs___default",
    path: "/souhrn/profil/zmena-jmena",
    meta: indexvFVsFYbRSzMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/name-change/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-name-change-requested___cs___default",
    path: "/souhrn/profil/zmena-jmena/overeni",
    meta: requestedZAFnfTYnVfMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/name-change/requested.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-name-change-upload-documents___cs___default",
    path: "/souhrn/profil/zmena-jmena/nahrat-doklady",
    meta: upload_45documentslw5lhrP3v5Meta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/name-change/upload-documents.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-permanent-address-change___cs___default",
    path: "/souhrn/profil/zmena-travale-adresy",
    meta: index63SVbAvTk6Meta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/permanent-address-change/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-permanent-address-change-requested___cs___default",
    path: "/souhrn/profil/zmena-travale-adresy/overeni",
    meta: requested904SLTDOy8Meta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/permanent-address-change/requested.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-permanent-address-change-upload-documents___cs___default",
    path: "/souhrn/profil/zmena-travale-adresy/nahrat-doklady",
    meta: upload_45documentsXJd1hn9VUvMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/permanent-address-change/upload-documents.vue").then(m => m.default || m)
  },
  {
    name: personal_45data_45confirmation3ExonrNP6KMeta?.name,
    path: "personal-data-confirmation",
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/personal-data-confirmation.vue").then(m => m.default || m),
    children: [
  {
    name: "dashboard-profile-personal-data-confirmation-additional-information___cs___default",
    path: "/souhrn/profil/aktualizace-udaju/dalsi-informace",
    meta: additional_45informationCLgafBGkErMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/personal-data-confirmation/additional-information.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-personal-data-confirmation___cs___default",
    path: "/souhrn/profil/aktualizace-udaju",
    meta: indexazuYDqQSHsMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/personal-data-confirmation/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-personal-data-confirmation-new-document___cs___default",
    path: "/souhrn/profil/aktualizace-udaju/novy-dokument",
    meta: index5kDwSPFfEjMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/personal-data-confirmation/new-document/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-personal-data-confirmation-new-document-requested___cs___default",
    path: "/souhrn/profil/aktualizace-udaju/novy-dokument/overeni",
    meta: requestedRBlrvZr7gUMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/personal-data-confirmation/new-document/requested.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-personal-data-confirmation-politically-exposed-person___cs___default",
    path: "/souhrn/profil/aktualizace-udaju/politicky-exponovana-osoba",
    meta: indexnnAV0mZ64OMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/personal-data-confirmation/politically-exposed-person/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-personal-data-confirmation-politically-exposed-person-requested___cs___default",
    path: "/souhrn/profil/aktualizace-udaju/politicky-exponovana-osoba/overeni",
    meta: requested3WF68ysyLbMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/personal-data-confirmation/politically-exposed-person/requested.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-personal-data-confirmation-source-of-income-statement___cs___default",
    path: "/souhrn/profil/aktualizace-udaju/potvrzeni-zdroje-prijmu",
    meta: indexrBJnIa3dKIMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/personal-data-confirmation/source-of-income-statement/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-personal-data-confirmation-source-of-income-statement-requested___cs___default",
    path: "/souhrn/profil/aktualizace-udaju/potvrzeni-zdroje-prijmu/overeni",
    meta: requestedIZeSkKDKGkMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/personal-data-confirmation/source-of-income-statement/requested.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "dashboard-profile-phone-change___cs___default",
    path: "/souhrn/profil/zmena-telefonu",
    meta: phone_45changeUAhiBCOEgfMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/phone-change.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-security___cs___default",
    path: "/souhrn/profil/bezpecnost",
    meta: indexHhPndUM5oeMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/security/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-security-password-change___cs___default",
    path: "/souhrn/profil/bezpecnost/zmena-hesla",
    meta: password_45changem74JQH9VpOMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/security/password-change.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-statements-and-documents-documents___cs___default",
    path: "/souhrn/profil/vypisy-a-dokumenty/dokumenty",
    meta: documents3H0iKZOq5QMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/statements-and-documents/documents.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-statements-and-documents___cs___default",
    path: "/souhrn/profil/vypisy-a-dokumenty",
    meta: indexTHxDA4WM5BMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/statements-and-documents/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-statements-and-documents-statements-and-confirmations___cs___default",
    path: "/souhrn/profil/vypisy-a-dokumenty/vypisy-a-potvrzeni",
    meta: statements_45and_45confirmationsycL7Y1rpZEMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/statements-and-documents/statements-and-confirmations.vue").then(m => m.default || m)
  }
]
  },
  {
    name: profileto2t7t7JCrMeta?.name,
    path: "/cs/dashboard/profile",
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile.vue").then(m => m.default || m),
    children: [
  {
    name: "dashboard-profile-add-account___cs",
    path: "/cs/souhrn/profil/pridat-ucet",
    meta: add_45accountsNAbTSj8YaMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/add-account.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-additional-settings___cs",
    path: "/cs/souhrn/profil/dalsi-nastaveni",
    meta: additional_45settingsbxnBvmBT7iMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/additional-settings.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-bank-accounts-add___cs",
    path: "/cs/souhrn/profil/bankovni-ucty/pridat",
    meta: indexa8esq9TNa8Meta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/bank-accounts/add/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-bank-accounts-add-requested___cs",
    path: "/cs/souhrn/profil/bankovni-ucty/pridat/overeni",
    meta: requestedf8IP0ac66dMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/bank-accounts/add/requested.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-bank-accounts-add-upload-document___cs",
    path: "/cs/souhrn/profil/bankovni-ucty/pridat/nahrat-doklad",
    meta: upload_45documentaHn4Ym3RZFMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/bank-accounts/add/upload-document.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-bank-accounts___cs",
    path: "/cs/souhrn/profil/bankovni-ucty",
    meta: indexRhPIuBk0MZMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/bank-accounts/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-delete-account___cs",
    path: "/cs/souhrn/profil/zruseni-uctu",
    meta: delete_45account7f2WVfSsCnMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/delete-account.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-document-update___cs",
    path: "/cs/souhrn/profil/aktualizace-dokladu",
    meta: index3YisySqiUUMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/document-update/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-document-update-requested___cs",
    path: "/cs/souhrn/profil/aktualizace-dokladu/overeni",
    meta: requested7Irg7sTBzQMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/document-update/requested.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-edit-personal-information___cs",
    path: "/cs/souhrn/profil/uprava-osobnich-udaju",
    meta: edit_45personal_45informationMY5g1IjW4RMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/edit-personal-information.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-email-change___cs",
    path: "/cs/souhrn/profil/zmena-e-mailu",
    meta: email_45changefCuvkFJsxmMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/email-change.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-email-preferences___cs",
    path: "/cs/souhrn/profil/e-mailova-sdeleni",
    meta: email_45preferencesNp6sCbnGkZMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/email-preferences.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-identity-verification-czech-point___cs",
    path: "/cs/souhrn/profil/overeni-totoznosti/czech-point",
    meta: czech_45pointXMOvb6Ym9CMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/identity-verification/czech-point.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-identity-verification___cs",
    path: "/cs/souhrn/profil/overeni-totoznosti",
    meta: indext7nD8Cpqu1Meta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/identity-verification/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile___cs",
    path: "/cs/souhrn/profil",
    meta: indexvJqbLhdUcXMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-mailing-address-change___cs",
    path: "/cs/souhrn/profil/zmena-korespondencni-adresy",
    meta: mailing_45address_45changeAAUXNJ72c5Meta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/mailing-address-change.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-name-change___cs",
    path: "/cs/souhrn/profil/zmena-jmena",
    meta: indexvFVsFYbRSzMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/name-change/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-name-change-requested___cs",
    path: "/cs/souhrn/profil/zmena-jmena/overeni",
    meta: requestedZAFnfTYnVfMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/name-change/requested.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-name-change-upload-documents___cs",
    path: "/cs/souhrn/profil/zmena-jmena/nahrat-doklady",
    meta: upload_45documentslw5lhrP3v5Meta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/name-change/upload-documents.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-permanent-address-change___cs",
    path: "/cs/souhrn/profil/zmena-travale-adresy",
    meta: index63SVbAvTk6Meta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/permanent-address-change/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-permanent-address-change-requested___cs",
    path: "/cs/souhrn/profil/zmena-travale-adresy/overeni",
    meta: requested904SLTDOy8Meta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/permanent-address-change/requested.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-permanent-address-change-upload-documents___cs",
    path: "/cs/souhrn/profil/zmena-travale-adresy/nahrat-doklady",
    meta: upload_45documentsXJd1hn9VUvMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/permanent-address-change/upload-documents.vue").then(m => m.default || m)
  },
  {
    name: personal_45data_45confirmation3ExonrNP6KMeta?.name,
    path: "personal-data-confirmation",
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/personal-data-confirmation.vue").then(m => m.default || m),
    children: [
  {
    name: "dashboard-profile-personal-data-confirmation-additional-information___cs",
    path: "/cs/souhrn/profil/aktualizace-udaju/dalsi-informace",
    meta: additional_45informationCLgafBGkErMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/personal-data-confirmation/additional-information.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-personal-data-confirmation___cs",
    path: "/cs/souhrn/profil/aktualizace-udaju",
    meta: indexazuYDqQSHsMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/personal-data-confirmation/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-personal-data-confirmation-new-document___cs",
    path: "/cs/souhrn/profil/aktualizace-udaju/novy-dokument",
    meta: index5kDwSPFfEjMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/personal-data-confirmation/new-document/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-personal-data-confirmation-new-document-requested___cs",
    path: "/cs/souhrn/profil/aktualizace-udaju/novy-dokument/overeni",
    meta: requestedRBlrvZr7gUMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/personal-data-confirmation/new-document/requested.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-personal-data-confirmation-politically-exposed-person___cs",
    path: "/cs/souhrn/profil/aktualizace-udaju/politicky-exponovana-osoba",
    meta: indexnnAV0mZ64OMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/personal-data-confirmation/politically-exposed-person/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-personal-data-confirmation-politically-exposed-person-requested___cs",
    path: "/cs/souhrn/profil/aktualizace-udaju/politicky-exponovana-osoba/overeni",
    meta: requested3WF68ysyLbMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/personal-data-confirmation/politically-exposed-person/requested.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-personal-data-confirmation-source-of-income-statement___cs",
    path: "/cs/souhrn/profil/aktualizace-udaju/potvrzeni-zdroje-prijmu",
    meta: indexrBJnIa3dKIMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/personal-data-confirmation/source-of-income-statement/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-personal-data-confirmation-source-of-income-statement-requested___cs",
    path: "/cs/souhrn/profil/aktualizace-udaju/potvrzeni-zdroje-prijmu/overeni",
    meta: requestedIZeSkKDKGkMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/personal-data-confirmation/source-of-income-statement/requested.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "dashboard-profile-phone-change___cs",
    path: "/cs/souhrn/profil/zmena-telefonu",
    meta: phone_45changeUAhiBCOEgfMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/phone-change.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-security___cs",
    path: "/cs/souhrn/profil/bezpecnost",
    meta: indexHhPndUM5oeMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/security/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-security-password-change___cs",
    path: "/cs/souhrn/profil/bezpecnost/zmena-hesla",
    meta: password_45changem74JQH9VpOMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/security/password-change.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-statements-and-documents-documents___cs",
    path: "/cs/souhrn/profil/vypisy-a-dokumenty/dokumenty",
    meta: documents3H0iKZOq5QMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/statements-and-documents/documents.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-statements-and-documents___cs",
    path: "/cs/souhrn/profil/vypisy-a-dokumenty",
    meta: indexTHxDA4WM5BMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/statements-and-documents/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-statements-and-documents-statements-and-confirmations___cs",
    path: "/cs/souhrn/profil/vypisy-a-dokumenty/vypisy-a-potvrzeni",
    meta: statements_45and_45confirmationsycL7Y1rpZEMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/dashboard/profile/statements-and-documents/statements-and-confirmations.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "element___cs___default",
    path: "/element",
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/element.vue").then(m => m.default || m)
  },
  {
    name: "element___cs",
    path: "/cs/element",
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/element.vue").then(m => m.default || m)
  },
  {
    name: "external-email-verification___cs___default",
    path: "/external/email-verification",
    meta: email_45verificationo1qgEblCjKMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/external/email-verification.vue").then(m => m.default || m)
  },
  {
    name: "external-email-verification___cs",
    path: "/cs/external/email-verification",
    meta: email_45verificationo1qgEblCjKMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/external/email-verification.vue").then(m => m.default || m)
  },
  {
    name: "external-impersonation___cs___default",
    path: "/external/impersonation",
    meta: impersonation80OHRpaFDwMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/external/impersonation.vue").then(m => m.default || m)
  },
  {
    name: "external-impersonation___cs",
    path: "/cs/external/impersonation",
    meta: impersonation80OHRpaFDwMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/external/impersonation.vue").then(m => m.default || m)
  },
  {
    name: "external-login___cs___default",
    path: "/external/login",
    meta: logink6nUGDLZfIMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/external/login.vue").then(m => m.default || m)
  },
  {
    name: "external-login___cs",
    path: "/cs/external/login",
    meta: logink6nUGDLZfIMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/external/login.vue").then(m => m.default || m)
  },
  {
    name: "external-password-reset___cs___default",
    path: "/external/password-reset",
    meta: password_45resetk1N6jOTU9gMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/external/password-reset.vue").then(m => m.default || m)
  },
  {
    name: "external-password-reset___cs",
    path: "/cs/external/password-reset",
    meta: password_45resetk1N6jOTU9gMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/external/password-reset.vue").then(m => m.default || m)
  },
  {
    name: faq9eXkZ4eybDMeta?.name,
    path: "/faq",
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/faq.vue").then(m => m.default || m),
    children: [
  {
    name: "faq-slug___cs___default",
    path: ":slug()",
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/faq/[slug].vue").then(m => m.default || m)
  },
  {
    name: "faq___cs___default",
    path: "",
    meta: indexsOOjN1fW5NMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/faq/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: faq9eXkZ4eybDMeta?.name,
    path: "/cs/faq",
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/faq.vue").then(m => m.default || m),
    children: [
  {
    name: "faq-slug___cs",
    path: ":slug()",
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/faq/[slug].vue").then(m => m.default || m)
  },
  {
    name: "faq___cs",
    path: "",
    meta: indexsOOjN1fW5NMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/faq/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "forgotten-password___cs___default",
    path: "/zapomenute-heslo",
    meta: forgotten_45password7zGvjbA7mIMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/forgotten-password.vue").then(m => m.default || m)
  },
  {
    name: "forgotten-password___cs",
    path: "/cs/zapomenute-heslo",
    meta: forgotten_45password7zGvjbA7mIMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/forgotten-password.vue").then(m => m.default || m)
  },
  {
    name: "how-does-it-work___cs___default",
    path: "/jak-to-funguje",
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/how-does-it-work.vue").then(m => m.default || m)
  },
  {
    name: "how-does-it-work___cs",
    path: "/cs/jak-to-funguje",
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/how-does-it-work.vue").then(m => m.default || m)
  },
  {
    name: "index___cs___default",
    path: "/",
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___cs",
    path: "/cs",
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "investments-offer-slug___cs___default",
    path: "/nabidka-investic/:slug()",
    meta: _91slug_93eURxcez7OeMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/investments-offer/[slug].vue").then(m => m.default || m)
  },
  {
    name: "investments-offer-slug___cs",
    path: "/cs/nabidka-investic/:slug()",
    meta: _91slug_93eURxcez7OeMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/investments-offer/[slug].vue").then(m => m.default || m)
  },
  {
    name: "investments-offer___cs___default",
    path: "/nabidka-investic",
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/investments-offer/index.vue").then(m => m.default || m)
  },
  {
    name: "investments-offer___cs",
    path: "/cs/nabidka-investic",
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/investments-offer/index.vue").then(m => m.default || m)
  },
  {
    name: "login___cs___default",
    path: "/prihlasit-se",
    meta: loginwm5pEiN65jMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/login.vue").then(m => m.default || m)
  },
  {
    name: "login___cs",
    path: "/cs/prihlasit-se",
    meta: loginwm5pEiN65jMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/login.vue").then(m => m.default || m)
  },
  {
    name: "obligatory-published-information___cs___default",
    path: "/povinne-informace",
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/obligatory-published-information.vue").then(m => m.default || m)
  },
  {
    name: "obligatory-published-information___cs",
    path: "/cs/povinne-informace",
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/obligatory-published-information.vue").then(m => m.default || m)
  },
  {
    name: "privacy-settings___cs___default",
    path: "/nastaveni-soukromi",
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/privacy-settings.vue").then(m => m.default || m)
  },
  {
    name: "privacy-settings___cs",
    path: "/cs/nastaveni-soukromi",
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/privacy-settings.vue").then(m => m.default || m)
  },
  {
    name: "registration___cs___default",
    path: "/registrace",
    meta: registrationXDRpjPEnTRMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/registration.vue").then(m => m.default || m)
  },
  {
    name: "registration___cs",
    path: "/cs/registrace",
    meta: registrationXDRpjPEnTRMeta || {},
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/registration.vue").then(m => m.default || m)
  },
  {
    name: "security___cs___default",
    path: "/bezpecnost",
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/security.vue").then(m => m.default || m)
  },
  {
    name: "security___cs",
    path: "/cs/bezpecnost",
    component: () => import("C:/FE02/_work/333/s/Gallery/pages/security.vue").then(m => m.default || m)
  }
]